import _ from "lodash";

require('../../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../../ComponentSet";

import utils from "../../../Utils";
import Constants from "../../../Constants";

const components = _.merge(ComponentSet,
    {
        'Branch'     : () => import('./components/Branch.vue'),
        'Institutions' : () => import('./components/Institutions.vue' ),
    });

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data: {
        now_branch_type_tag : 'Branch'
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData();        
    },
    methods: {
        setNewsTag(tagName){
            this.now_branch_type_tag = tagName;
        }
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        medicalSystemData() {
            return _.get(this, 'contentData.medicalSystemData', []) || [];
        },
    }, // end of computed
}).$mount('#app');